import { all } from 'redux-saga/effects';
import userAuthSaga from './auth/login.saga';
import notificationSaga from './notification/index.saga';
import userSaga from "./user/user.saga";
import pushNotificationsSubscriptionSaga from './auth/pushNotificationsSubscription.saga';

export default function* rootSaga() {
  yield all([
    userAuthSaga(),
    notificationSaga(),
    userSaga(),
    pushNotificationsSubscriptionSaga(),
  ]);
}
